module.exports = __webpack_public_path__ + "static/media/texture.6a85937c.jpg";